/**
 * Registers the Phase 1 service worker (public/sw.js) — production
 * builds only, and only when the browser supports it. Registration
 * failure must never block the app: PWA installability is a nice-to-
 * have layer on top of the UI, never a requirement for it to render —
 * consistent with ui/README.md's Absolute Product Safety Invariant (the
 * UI, this service worker included, is never a prerequisite for
 * anything the production pipeline does).
 */
export function registerServiceWorker(): void {
  if (typeof navigator === "undefined" || !("serviceWorker" in navigator)) return;
  if (import.meta.env.DEV) return; // avoid interfering with Vite's dev server/HMR

  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").catch(() => {
      // Silent — installability is best-effort, never a hard requirement.
    });
  });
}
